export type ResponsiveValue<T> = { mobile: T; desktop: T; desktopLg: T };

export const parseResponsiveValue = <T>(
  value: Partial<ResponsiveValue<T>> | T | undefined,
  { defaultValue }: { defaultValue?: T } = {}
): ResponsiveValue<T> => {
  if (value === null) {
    // Believe it or not typeof null is 'object'... handle that separately
    return { mobile: null, desktopLg: null, desktop: null };
  }
  switch (typeof value) {
    case 'object':
      return { ...{ mobile: defaultValue, desktopLg: defaultValue, desktop: defaultValue }, ...value };
    case 'undefined':
      return { mobile: defaultValue, desktopLg: defaultValue, desktop: defaultValue };
    default:
      return { mobile: value, desktop: value, desktopLg: value };
  }
};

export const mergeResponsiveValues = <T>(
  ...values: (Partial<ResponsiveValue<T>> | T | undefined)[]
): ResponsiveValue<T> => {
  return values.slice(1).reduce((finalValue: ResponsiveValue<T>, currentValue) => {
    currentValue = parseResponsiveValue<T>(currentValue);
    return {
      desktop: currentValue.desktop === undefined ? finalValue.desktop : currentValue.desktop,
      desktopLg: currentValue.desktopLg === undefined ? finalValue.desktopLg : currentValue.desktopLg,
      mobile: currentValue.mobile === undefined ? finalValue.mobile : currentValue.mobile,
    };
  }, parseResponsiveValue<T>(values[0])) as ResponsiveValue<T>;
};
